/* unplugin-vue-components disabled */import { render } from "./SchoolType.vue?vue&type=template&id=56ea816b&scoped=true"
import script from "./SchoolType.vue?vue&type=script&lang=js"
export * from "./SchoolType.vue?vue&type=script&lang=js"

import "./SchoolType.vue?vue&type=style&index=0&id=56ea816b&scoped=true&lang=css"

import exportComponent from "E:\\projects\\git\\company\\www_dixiang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ea816b"]])

export default __exports__